/**
 * Per-retailer currency policy
 *
 * Derives the effective currency rules from a retailer's `currenciesSupported`
 * list (carried on partner branding). When a retailer offers only one currency,
 * that currency is forced and the currency toggle is removed from all displays;
 * the estimate output still shows "Price is displayed in …".
 */

import { Currency } from '../types';

export interface CurrencyPolicy {
  /** Currencies the retailer offers (defaults to both when unset). */
  allowed: Currency[];
  /** Whether the user may switch currencies (more than one allowed). */
  canToggle: boolean;
  /** The single forced currency, or null when toggling is allowed. */
  forced: Currency | null;
}

export function currencyPolicy(currenciesSupported: readonly string[] | null | undefined): CurrencyPolicy {
  const filtered = (currenciesSupported ?? []).filter(
    (c): c is Currency => c === 'USD' || c === 'CAD',
  );
  const allowed = filtered.length ? filtered : (['USD', 'CAD'] as Currency[]);
  return {
    allowed,
    canToggle: allowed.length > 1,
    forced: allowed.length === 1 ? allowed[0] : null,
  };
}
